{
  "shop.title": "Butik",
  "shop.subtitle": "Beställ produkter från ColorGlo HQ.",
  "shop.search": "Sök produkt eller artikelnummer",
  "shop.category.all": "Alla",
  "shop.empty": "Inga produkter matchar sökningen.",
  "shop.error": "Butiken kunde inte laddas.",
  "shop.retry": "Försök igen",
  "shop.sizes.one": "{count} storlek",
  "shop.sizes.other": "{count} storlekar",
  "shop.no_image": "Ingen bild",
  "shop.back": "Tillbaka till butiken",
  "shop.product.not_found": "Produkten finns inte längre i butiken.",
  "shop.product.variants": "Storlekar",
  "shop.product.sku": "Art.nr",
  "shop.product.size": "Storlek",
  "shop.product.status": "Status",
  "shop.product.size_missing": "Ej angiven",
  "shop.product.orderable": "Kan beställas",
  "shop.product.unavailable": "Kan inte beställas",
  "shop.product.video": "Se film",
  "shop.product.content": "Produktinformation",
  "shop.cart.title": "Varukorg",
  "shop.cart.add": "Lägg i varukorgen",
  "shop.cart.added": "{name} ligger i varukorgen.",
  "shop.cart.empty": "Varukorgen är tom.",
  "shop.cart.browse": "Till butiken",
  "shop.cart.qty": "Antal",
  "shop.cart.decrease": "Minska antal",
  "shop.cart.increase": "Öka antal",
  "shop.cart.remove": "Ta bort",
  "shop.cart.unavailable": "Kan inte beställas längre och skickas inte med.",
  "shop.cart.notes": "Meddelande till HQ",
  "shop.cart.notes_hint": "Valfritt, till exempel önskad leveransdag.",
  "shop.cart.submit": "Skicka beställning",
  "shop.cart.sending": "Skickar …",
  "shop.cart.sent": "Beställningen är skickad till HQ.",
  "shop.cart.failed": "Beställningen kunde inte skickas. Försök igen.",
  "shop.cart.review_note": "HQ går igenom beställningen och kan sänka antal om något saknas i lager.",
  "shop.orders.title": "Mina beställningar",
  "shop.orders.empty": "Inga beställningar än.",
  "shop.orders.number": "Order {number}",
  "shop.orders.date": "Datum",
  "shop.orders.status": "Status",
  "shop.orders.items.one": "{count} artikel",
  "shop.orders.items.other": "{count} artiklar",
  "shop.orders.back": "Alla beställningar",
  "shop.orders.error": "Beställningarna kunde inte laddas.",
  "shop.order.not_found": "Beställningen hittades inte.",
  "shop.order.lines": "Artiklar",
  "shop.order.product": "Produkt",
  "shop.order.ordered": "Beställt",
  "shop.order.approved_qty": "Godkänt",
  "shop.order.delivery": "Leveransadress",
  "shop.order.notes": "Meddelande från verkstaden",
  "shop.order.history": "Historik",
  "shop.order.cancel": "Avbryt beställningen",
  "shop.order.cancel_confirm": "Avbryta order {number}? Det går inte att ångra.",
  "shop.order.keep": "Behåll",
  "shop.order.cancelled_toast": "Beställningen är avbruten.",
  "shop.order.placed_by": "Lagd av {name}",
  "shop.order.adjusted": "Justerat av HQ",
  "shop.status.submitted": "Väntar på HQ",
  "shop.status.approved": "Godkänd",
  "shop.status.rejected": "Avvisad",
  "shop.status.shipped": "Skickad",
  "shop.status.cancelled": "Avbruten",
  "shop.event.submitted": "Beställningen skickades",
  "shop.event.approved": "HQ godkände beställningen",
  "shop.event.rejected": "HQ avvisade beställningen",
  "shop.event.shipped": "HQ skickade beställningen",
  "shop.event.cancelled": "Beställningen avbröts",
  "shop.hq.title": "Beställningar",
  "shop.hq.subtitle": "Beställningar från verkstäderna.",
  "shop.hq.all": "Alla",
  "shop.hq.workshop": "Verkstad",
  "shop.hq.empty": "Inga beställningar här.",
  "shop.hq.decision": "Beslut",
  "shop.hq.approve": "Godkänn",
  "shop.hq.approve_hint": "Sänk antalet eller sätt 0 för det som saknas i lager.",
  "shop.hq.note": "Meddelande till verkstaden",
  "shop.hq.reject": "Avvisa",
  "shop.hq.reject_reason": "Anledning",
  "shop.hq.reject_hint": "Verkstaden ser anledningen.",
  "shop.hq.approved_toast": "Beställningen är godkänd.",
  "shop.hq.rejected_toast": "Beställningen är avvisad.",
  "shop.hq.nothing_left": "Minst en rad måste vara kvar. Avvisa beställningen i stället.",
  "shop.hq.failed": "Det gick inte att spara beslutet. Försök igen.",
  "shop.orders.order": "Order",
  "shop.invoice.title": "Följesedel",
  "shop.invoice.invoice_number": "Följesedelnummer",
  "shop.invoice.invoice_date": "Datum",
  "shop.invoice.order_number": "Ordernummer",
  "shop.invoice.order_date": "Orderdatum",
  "shop.invoice.ship_date": "Skickad",
  "shop.invoice.seller": "Från",
  "shop.invoice.buyer": "Till",
  "shop.invoice.org_nr": "Org.nr",
  "shop.invoice.vat_nr": "Momsreg.nr",
  "shop.invoice.sku": "Art.nr",
  "shop.invoice.product": "Produkt",
  "shop.invoice.qty": "Antal",
  "shop.invoice.download": "Ladda ner följesedel {number}",
  "shop.email.order_placed.subject": "Ny beställning {number} från {workshop}",
  "shop.email.order_placed.heading": "Ny beställning från {workshop}",
  "shop.email.order_placed.body": "{workshop} har skickat order {number}. Den väntar på ert beslut.",
  "shop.email.order_approved.subject": "Order {number} är godkänd",
  "shop.email.order_approved.heading": "Er beställning är godkänd",
  "shop.email.order_approved.body": "HQ har godkänt order {number}. Vi meddelar er när den skickas.",
  "shop.email.order_rejected.subject": "Order {number} är avvisad",
  "shop.email.order_rejected.heading": "Er beställning kunde inte tas emot",
  "shop.email.order_rejected.body": "HQ har tyvärr avvisat order {number}.",
  "shop.email.order_shipped.subject": "Order {number} är skickad – följesedel {invoice}",
  "shop.email.order_shipped.heading": "Er beställning är på väg",
  "shop.email.order_shipped.body": "Order {number} har skickats. Följesedel {invoice} ligger bifogad.",
  "shop.email.adjusted": "HQ har justerat antalet på en eller flera rader.",
  "shop.email.note": "Meddelande från HQ: {note}",
  "shop.email.reason": "Anledning: {note}",
  "shop.email.cta": "Visa beställningen",
  "shop.hq.ship": "Markera som skickad",
  "shop.hq.ship_confirm": "En leverans registreras för order {number}. En följesedel för det som skickas skapas och mejlas till verkstaden. Det går inte att ångra.",
  "shop.hq.shipped_toast": "Ordern är skickad och följesedeln är skapad.",
  "shop.order.invoice": "Följesedel {number}, {date}",
  "shop.hq.not_now": "Inte nu",
  "shop.admin.title": "Produkter",
  "shop.admin.subtitle": "Butikens sortiment och vad som kan beställas.",
  "shop.admin.search": "Sök produkt eller artikelnummer",
  "shop.admin.new": "Ny produkt",
  "shop.admin.create": "Skapa",
  "shop.admin.name": "Namn",
  "shop.admin.category": "Kategori",
  "shop.admin.summary": "Kort beskrivning",
  "shop.admin.content": "Produktinformation",
  "shop.admin.content_hint": "Tom rad mellan stycken. **fet text** för rubriker som Applicering:.",
  "shop.admin.video": "Filmlänk",
  "shop.admin.active": "Visas i butiken",
  "shop.admin.hidden": "Dold",
  "shop.admin.visible": "Visas",
  "shop.admin.blocked.one": "{count} spärrad",
  "shop.admin.blocked.other": "{count} spärrade",
  "shop.admin.save": "Spara",
  "shop.admin.saved": "Sparat.",
  "shop.admin.failed": "Det gick inte att spara. Kontrollera fälten och försök igen.",
  "shop.admin.back": "Alla produkter",
  "shop.admin.image": "Bild",
  "shop.admin.upload": "Ladda upp bild",
  "shop.admin.upload_hint": "JPEG, PNG eller WebP, högst 3 MB.",
  "shop.admin.variants": "Storlekar",
  "shop.admin.sku": "Art.nr",
  "shop.admin.size": "Storlek",
  "shop.admin.orderable": "Kan beställas",
  "shop.admin.add_variant": "Lägg till storlek",
  "shop.admin.settings": "Inställningar",
  "shop.admin.settings_title": "Butiksinställningar",
  "shop.admin.seller": "Avsändare på följesedeln",
  "shop.admin.seller_hint": "Står överst på varje följesedel. Org.nr och momsreg.nr visas när de är ifyllda.",
  "shop.admin.legal_name": "Företagsnamn",
  "shop.admin.address": "Adress",
  "shop.admin.postcode": "Postnummer",
  "shop.admin.city": "Ort",
  "shop.admin.email": "E-post",
  "shop.admin.phone": "Telefon",
  "shop.admin.org_nr": "Org.nr",
  "shop.admin.vat_nr": "Momsreg.nr",
  "shop.admin.empty": "Inga produkter matchar sökningen.",
  "shop.hq_bell.open": "Visa HQ-aviseringar",
  "shop.hq_bell.title": "Beställningar från verkstäder",
  "shop.hq_bell.empty": "Inga nya beställningar.",
  "shop.hq_bell.kind.shop_order_placed": "Ny beställning",
  "shop.hq_bell.kind.shop_order_cancelled": "Beställning avbruten",
  "shop.hq_bell.body": "{workshop} · order {number}",
  "shop.hq_bell.mark_all_read": "Markera alla som lästa",
  "shop.hq_bell.see_all": "Visa alla",
  "shop.hq_history.title": "Orderaviseringar",
  "shop.hq_history.unread.one": "{count} oläst",
  "shop.hq_history.unread.other": "{count} olästa",
  "shop.hq_history.all_read": "Allt är läst.",
  "shop.hq_history.unread_only": "Endast olästa",
  "shop.hq_history.empty": "Inga aviseringar ännu.",
  "shop.hq_history.empty_filtered": "Inget matchar filtret.",
  "shop.hq_history.load_more": "Visa fler",
  "shop.hq_history.error": "Aviseringarna kunde inte laddas.",
  "shop.email.order_cancelled.subject": "Order {number} är avbruten av HQ",
  "shop.email.order_cancelled.heading": "Er beställning är avbruten",
  "shop.email.order_cancelled.body": "HQ har avbrutit order {number}. Inget har skickats.",
  "shop.email.order_closed.subject": "Order {number} är klar – resten skickas inte",
  "shop.email.order_closed.heading": "Er beställning är klar",
  "shop.email.order_closed.body": "HQ har skickat det som fanns i lager av order {number}. Resten skickas inte och ordern gäller nu bara det som skickats, enligt följesedlarna.",
  "shop.email.short_line": "{product}: {qty} av {ordered} skickade",
  "shop.email.tracking": "Spårningsnummer: {tracking}",
  "shop.status.partially_shipped": "Delvis skickad",
  "shop.status.delivered": "Levererad",
  "shop.event.partially_shipped": "HQ skickade en del av beställningen",
  "shop.event.delivered": "Verkstaden har tagit emot beställningen",
  "shop.hq_bell.kind.shop_order_delivered": "Beställning mottagen",
  "shop.order.shipped_qty": "Skickat",
  "shop.order.shipments": "Leveranser",
  "shop.order.shipment": "Leverans {number}",
  "shop.order.tracking": "Spårning: {tracking}",
  "shop.order.no_tracking": "Inget spårningsnummer",
  "shop.order.received": "Bekräfta mottagen",
  "shop.order.received_confirm": "Har hela beställningen kommit fram?",
  "shop.order.received_toast": "Tack! Beställningen är markerad som mottagen.",
  "shop.hq.ship_title": "Skicka",
  "shop.hq.ship_hint": "Ange hur många som skickas nu. Resten kan skickas senare.",
  "shop.hq.tracking": "Spårningsnummer",
  "shop.hq.ship_now": "Skicka",
  "shop.hq.to_ship": "Att skicka",
  "shop.hq.cancel": "Avbryt ordern",
  "shop.hq.cancel_hint": "Inget har skickats. Verkstaden ser anledningen.",
  "shop.hq.cancelled_toast": "Ordern är avbruten.",
  "shop.hq.close": "Avsluta utan resten",
  "shop.hq.close_hint": "Det som inte skickats tas bort från ordern, och ordern gäller bara det som skickats. Verkstaden får ett mejl med anledningen.",
  "shop.hq.closed_toast": "Ordern är avslutad.",
  "shop.cart.delivery": "Leveransadress",
  "shop.cart.delivery_workshop": "Verkstadens adress",
  "shop.cart.delivery_other": "Annan adress",
  "shop.cart.delivery_incomplete": "Verkstadens adress är inte komplett. Ange en leveransadress.",
  "shop.cart.delivery_name": "Mottagare",
  "shop.cart.delivery_line1": "Gatuadress",
  "shop.cart.delivery_line2": "C/o eller våning (valfritt)",
  "shop.cart.delivery_postcode": "Postnummer",
  "shop.cart.delivery_city": "Ort",
  "shop.cart.no_longer_available": "Finns inte längre i butiken och skickas inte med.",
  "shop.paused": "Verkstaden är pausad och kan inte beställa just nu.",
  "shop.email_log.title": "E-post",
  "shop.email_log.empty": "Inga mejl ännu.",
  "shop.email_log.kind.order_placed": "Ny beställning till HQ",
  "shop.email_log.kind.order_approved": "Godkänd",
  "shop.email_log.kind.order_rejected": "Avvisad",
  "shop.email_log.kind.order_shipped": "Leverans {number} med följesedel",
  "shop.email_log.kind.order_cancelled": "Avbruten av HQ",
  "shop.email_log.kind.order_closed": "Avslutad utan resten",
  "shop.email_log.status.pending": "Väntar",
  "shop.email_log.status.sent": "Skickat",
  "shop.email_log.status.failed": "Misslyckades",
  "shop.email_log.resend": "Skicka igen",
  "shop.email_log.resent": "Mejlet skickas igen.",
  "shop.export.title": "Export",
  "shop.export.hint": "Excel-fil (CSV) för vald period.",
  "shop.export.from": "Från",
  "shop.export.to": "Till",
  "shop.export.orders": "Orderrader",
  "shop.export.invoices": "Följesedlar",
  "shop.admin.language": "Språk",
  "shop.admin.translation_hint": "Tomt fält visar den svenska texten.",
  "shop.admin.categories": "Kategorier",
  "shop.admin.categories_hint": "Namn på alla språk. Tomt fält visar det svenska namnet.",
  "shop.admin.new_category": "Ny kategori",
  "shop.admin.move_up": "Flytta upp",
  "shop.admin.move_down": "Flytta ned",
  "shop.admin.delete": "Ta bort",
  "shop.admin.delete_product": "Ta bort produkten",
  "shop.admin.delete_confirm": "Ta bort {name}? Det går bara om ingen har beställt den. Annars, dölj den i stället.",
  "shop.admin.deleted": "Borttagen.",
  "shop.admin.in_use": "Kan inte tas bort eftersom den har beställts. Dölj den i stället.",
  "shop.admin.category_in_use": "Kategorin har produkter och kan inte tas bort.",
  "shop.analytics.tab": "Butik",
  "shop.analytics.title": "Butiken i nätverket",
  "shop.analytics.body": "Beställningar från verkstäderna under vald period.",
  "shop.analytics.orders": "Ordrar",
  "shop.analytics.fill_rate": "Leveransgrad",
  "shop.analytics.fill_rate_hint": "Andel av beställt antal som HQ godkände.",
  "shop.analytics.approve_time": "Tid till beslut",
  "shop.analytics.ship_time": "Tid till leverans",
  "shop.analytics.deliver_time": "Tid till mottagen",
  "shop.analytics.median": "Median",
  "shop.analytics.hours": "{value} h",
  "shop.analytics.days": "{value} d",
  "shop.analytics.none": "—",
  "shop.analytics.statuses": "Status",
  "shop.analytics.per_day": "Ordrar per dag",
  "shop.analytics.chart_label": "{count} ordrar mellan {from} och {to}",
  "shop.analytics.workshops": "Verkstäder",
  "shop.analytics.workshop": "Verkstad",
  "shop.analytics.country": "Land",
  "shop.analytics.last_order": "Senaste order",
  "shop.analytics.no_orders": "Inga ordrar",
  "shop.analytics.products": "Mest beställda produkter",
  "shop.analytics.qty": "Antal",
  "shop.analytics.ordered_by": "Verkstäder",
  "shop.analytics.empty": "Inga beställningar under perioden.",
  "shop.analytics.error": "Siffrorna kunde inte laddas.",
  "shop.cart.summary": "Din beställning",
  "shop.analytics.units": "Godkända enheter",
  "shop.analytics.delivery_notes": "Följesedlar"
}
